import { ReactNode } from 'react';

type Tone = 'green' | 'yellow' | 'red' | 'gray' | 'blue' | 'purple';

const TONE_CLASS: Record<Tone, string> = {
  green: 'bg-emerald-600/20 text-emerald-300 border-emerald-700/40',
  yellow: 'bg-amber-600/20 text-amber-300 border-amber-700/40',
  red: 'bg-red-600/20 text-red-300 border-red-700/40',
  gray: 'bg-slate-700/40 text-slate-300 border-slate-700/60',
  blue: 'bg-blue-600/20 text-blue-300 border-blue-700/40',
  purple: 'bg-purple-600/20 text-purple-300 border-purple-700/40',
};

const STATUS_TONE: Record<string, Tone> = {
  active: 'green',
  done: 'green',
  completed: 'green',
  ok: 'green',

  dormant: 'yellow',
  pending: 'yellow',
  queued: 'yellow',
  running: 'blue',
  processing: 'blue',

  banned: 'red',
  failed: 'red',
  error: 'red',

  churned: 'gray',
};

export interface StatusBadgeProps {
  status: string;
  className?: string;
  children?: ReactNode;
}

export function StatusBadge({ status, className = '', children }: StatusBadgeProps) {
  const key = (status || '').toLowerCase().trim();
  const tone: Tone = STATUS_TONE[key] ?? 'gray';
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium ${TONE_CLASS[tone]} ${className}`}
      aria-label={`status: ${status}`}
    >
      {children ?? status}
    </span>
  );
}
